import { render, staticRenderFns } from "./LanguageTranslationNewPopup.vue?vue&type=template&id=3145ebe0&"
import script from "./LanguageTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./LanguageTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports